import {
  createSlice,
  handleFilters,
  handleFilterConfigs,
  handleDefaultParams,
  replaceFilters,
  restoreFilterSnapshot,
  copyFilterSnapshot,
  applyFilter,
  removeFilter,
  deepMergeFilters
} from "../helper";

const connectionViewFiltersSlice = createSlice({
  name: 'ConnectionViewFilters',
  initialState: {},
  reducers: {
    handleConnectionViewFilters(prevState, action) {
      handleFilters(prevState, action);
    },
    handleConnectionViewFilterConfigs(prevState, action) {
      handleFilterConfigs(prevState, action);
    },
    handleConnectionViewFilterDefaultParams(prevState, action) {
      handleDefaultParams(prevState, action);
    },
    handleConnectionViewFilterErrors(prevState, action) {
      const uId = action.payload.uId;
      const newErrorsData = action.payload.data;
      prevState.form[uId].errors = newErrorsData;
    },
    replaceConnectionViewFilters(_prevState, action) {
      return replaceFilters(_prevState, action);
    },
    deepMergeConnectionViewFilters(prevState, action) {
      return deepMergeFilters(prevState, action);
    },
    restoreConnectionViewFilterSnapshot(prevState, action) {
      restoreFilterSnapshot(prevState, action);
    },
    copyConnectionViewFilterSnapshot(prevState, action) {
      copyFilterSnapshot(prevState, action);
    },
    applyConnectionViewFilter(prevState, action) {
      applyFilter(prevState, action);
    },
    removeConnectionViewFilter(prevState, action) {
      removeFilter(prevState, action);
    },
    setConnectionViewFilterStatus(prevState, action) {
      const status = action.payload.data.status;
      prevState.status = status;
    }
  }
});

export const filterActions = connectionViewFiltersSlice.actions;

export default connectionViewFiltersSlice;
